<template>
  <v-card>
    <v-card-title>
      <span v-if="editMode" class="text-h5">
        {{ $t('ITEM.EDIT') }} {{ $t('BUILDINGS.ITEM') }}
      </span>
      <span v-else class="text-h5">
        {{ $t('ITEM.SHOW') }} {{ $t('BUILDINGS.ITEM') }}
      </span>

      <v-spacer />

      <v-btn icon @click="cancel">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-card-title>

    <v-card-text>
      <v-row dense>
        <v-col :cols="editMode ? 12 : 6">
          <v-form ref="form" v-model="valid" lazy-validation>
            <building-form
              v-if="form"
              v-model="form"
              :readonly="!editMode"
              :errors="errors.getAll()"
              v-bind="$attrs"
              @update-prop="clearErrorByName($event)"
            />
          </v-form>
        </v-col>
        <v-divider vertical class="mx-5" />
        <v-col v-if="!editMode" col="6">
          <documents-for-building :building="form"></documents-for-building>
        </v-col>
      </v-row>
    </v-card-text>

    <v-card-actions v-if="editMode">
      <v-btn outlined depressed color="grey" @click="cancelEdit">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer />
      <v-btn
        depressed
        color="primary"
        :disabled="!valid"
        @click="updateBuilding"
      >
        {{ $t('BUTTON.UPDATE') }}
      </v-btn>
    </v-card-actions>
    <v-card-actions v-else>
      <v-btn outlined depressed color="grey" @click="cancel">
        {{ $t('BUTTON.CANCEL') }}
      </v-btn>
      <v-spacer />
      <v-btn depressed color="primary" @click="toggleEditMode">
        {{ $t('BUTTON.EDIT') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import BuildingForm from '@/modules/buildings/components/form/BuildingForm';
import editComponent from '@/modules/_global/mixins/edit-component';
import DocumentsForBuilding from '@/components/documents/DocumentsForBuilding';
import { cloneDeep } from 'lodash';
import { mapActions } from 'vuex';

export default {
  name: 'ShowBuilding',
  components: { BuildingForm, DocumentsForBuilding },

  mixins: [editComponent],

  data: () => ({}),

  computed: {},

  mounted() {
    this.refreshData();
  },

  methods: {
    ...mapActions('building', ['update']),
    refreshData() {},

    cancelEdit() {
      this.$nextTick(() => {
        this.form = cloneDeep(this.formCopy);
        this.toggleEditMode();
      });
    },

    updateBuilding() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.update(this.form)
        .then(({ data }) => {
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
          this.$emit('updated');
        })
        .catch(({ response }) => {
          this.handleErrorsByResponse(response);
        });
    }
  }
};
</script>

<style scoped></style>
